<style>
</style>
<template style="height: 100%">
    <v-card style="height: 100%">
        <v-toolbar class="elevation1">
            <v-toolbar-title>Student Bubble Chart: {{ studentName }}</v-toolbar-title>
            <v-tooltip bottom>
                <v-btn slot="activator" fab dark small color="primary" outline ref="icon"
                    :to="{ name: 'StudentDashboard', params: { studentId: this.$route.params.studentId }}"
                ><v-icon dark>dashboard</v-icon>
                </v-btn>
                <span>Go Back to Dashboard</span>
              </v-tooltip>
        </v-toolbar>
        <v-alert v-model="noDataNotification" icon="warning" outline>
            The selected student has no data to display
        </v-alert>
        <br>
        <div id="studentMotionChart" style="width: 95%; height: 90%"></div>
    </v-card>
</template>

<script>

    import { initialize, getReportingDates, getStudent, getMotionChartInformation, getTabsSettings } from '../utils/effort-tracking-api'
    import * as echarts from '../../node_modules/echarts/dist/echarts.min'

    export default {
        name: 'student-motionchart',
        data() {
            return {
                periods: [],
                studentId: this.$route.params.studentId,
                reportingPeriodId: localStorage.getItem('period-selected'),
                noDataNotification: false,
                selectedReportingDate: null,
                reportingDates: [],
                hasData: false,
                reportingDate: null,
                studentName: ''
                }
        },
        mounted() {

            var myContainer = document.getElementsByClassName('container')[0];
            myContainer.style.height = "95%";

            this.periods = this.$store.state.periods;
            initialize().then(result => {
                getStudent(this.$route.params.studentId).then(student => {
                    
                    this.studentName = `${student.lastName}, ${student.firstName}`;
                    
                    // Initialize the echarts instance based on the prepared dom
                    var myChart = echarts.init(document.getElementById('studentMotionChart'), {renderer: 'canvas'} );
                    myChart.showLoading();
                    
                    getMotionChartInformation(this.$route.params.studentId).then(data => {
                        
                        if(data.grades.length > 0)
                        {

                            getTabsSettings().then(tabs => {
                        
                                var diligence = tabs.filter(tb => tb.name == 'DILIGENCE')[0];
                                var diligenceLabel = (diligence.customName !== '' ) ? diligence.customName : diligence.name;

                                var engagement = tabs.filter(tb => tb.name == "ENGAGEMENT")[0];
                                var engagementLabel = (engagement.customName !== '' ) ? engagement.customName : engagement.name;

                                var behaviour = tabs.filter(tb => tb.name == "BEHAVIOUR")[0];
                                var behaviourLabel = (behaviour.customName !== '' ) ? behaviour.customName : behaviour.name;            

                                // Specify the configuration items and data for the chart
                                var studentName =  `${student.firstName} ${student.lastName}`;
                                var categoryTimeLine = [];
                                var lineSeries = [];
                                var studentSeries = [];

                                data.grades.forEach(function(serie)
                                    {
                                        // Fill timeline
                                        categoryTimeLine.push(serie.reportingName);
                                        
                                        // Fill Series for selected student
                                        var tmpSeries = [];
                                        lineSeries.push([serie.effortScore, serie.academicScore]);
                                        
                                        tmpSeries = tmpSeries.concat(lineSeries);

                                        var studentMarker = {coord: [serie.effortScore, serie.academicScore]};
                                        var MarkerTooltip = {formatter: studentName +  ':<br /><br />' +
                                                                        '<b>Teacher rated effort: </b>' + serie.effortScore + '<br />' +
                                                                        '<b>Student rated effort: </b>' + serie.studentEffortScore + '<br />' +
                                                                        '<b>'+ diligenceLabel +': </b>' + serie.teacherDiligenceScore + '<br />' +
                                                                        '<b>'+ engagementLabel +': </b>' + serie.teacherEngagementScore + '<br />' +
                                                                        '<b>'+ behaviourLabel +': </b>' + serie.teacherBehaviourScore};

                                        var studentSerie = {
                                            series: [{name: 'Other Students', type: 'scatter',data: serie.anonymousSeries, symbolSize: 10, color:'lightgrey', tooltip: {show: false}}
                                                    ,{name: 'Your Effort', type: 'line', data: tmpSeries, lineStyle: {cap: "butt",type: "dashed"}, markPoint: {data: [studentMarker],symbol: "pin", tooltip: MarkerTooltip}, tooltip: {show: false}}
                                                    ,{name: 'You', type: 'effectScatter', data: tmpSeries, tooltip: {show: false}, symbolSize: 20, symbol:'circle'}],
                                            animationDuration: 1000,
                                            animationEasing: 'linear',
                                            animationDurationUpdate: 1500,
                                            animationEasingUpdate: 'linear'
                                        };

                                        studentSeries.push(studentSerie);
                                    }
                                );

                                var option = {
                                    baseOption: {
                                        legend: {},
                                        timeline: {
                                            axisType: 'category',
                                            autoPlay: false,
                                            loop: false,
                                            data: categoryTimeLine,
                                            checkpointStyle: {
                                                animation: true,
                                                animationDuration: 1500,
                                                animationEasing: 'linear'
                                            }
                                        },
                                        toolbox: {
                                            right: 40,
                                            top: 30,
                                            feature: {
                                                dataZoom: {}
                                            }
                                        },
                                        tooltip: {
                                            trigger: "item"
                                        },
                                        xAxis: {
                                            name: 'Effort Score',
                                            type: 'value',
                                            min: 0,
                                            max: 100, 
                                        },
                                        yAxis: {
                                            name: 'Academic Score',
                                            type: 'value',
                                            min: 0, 
                                            max: 100,
                                        },
                                        series: [{name: 'Other Students', type: 'scatter', data: [], symbolSize: 10, color:'lightgrey'}
                                                ,{name: 'Your Effort', type: 'line', data: [], lineStyle: {cap: "butt",type: "dashed"}, markPoint: {data: [],symbol: "pin"}}
                                                ,{name: 'You',type: 'effectScatter', data: [], tooltip: {show: false}, symbolSize: 20, symbol:'circle'}],
                                        animationDuration: 1000,
                                        animationEasing: 'linear',
                                        animationDurationUpdate: 1500,
                                        animationEasingUpdate: 'linear'
                                    },
                                    
                                    // options deberían ser vacias y luego hacer un push a medida que recorre el dataset. Ver ejemplo de eCharts sobre población en linea de tiempo
                                    options: studentSeries
                                };

                                myChart.setOption(option);
                                myChart.hideLoading();
                        
                            }).catch(ex => console.log(ex));
                        }
                        else
                        {
                            this.noDataNotification = true;
                            myChart.hideLoading();
                        }
                    }).catch(ex => console.log(ex));
                }).catch(ex => console.log(ex));
            });
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (to.meta.requiresResourceProperty && vm.$store.state.usertype == 'student')
                {
                    if (parseInt(vm.$store.state.userdata.id) !== parseInt(vm.$route.params.studentId))
                    {
                        vm.$route.params.studentId = vm.$store.state.userdata.id;
                        window.location.href = '#/';
                    }
                }
            });
        },
        beforeMount() {
            window.addEventListener("resize",function(){
                var myChart = echarts.getInstanceByDom(document.getElementById('studentMotionChart'));
                myChart.resize();
            });
        },
        beforeRouteLeave(to, from, next) {
            var myChart = echarts.getInstanceByDom(document.getElementById('studentMotionChart'));
            myChart.dispose();
            next();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/StudentMotionChart.vue